import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentCarrier from './content-carrier-model'
import {
  delete_contentCarrier,
  load_contentCarriers,
  store_contentCarrier,
} from './contentCarrier-service'

export const LoadContentCarriersAsync = createAsyncThunk<any, any>(
  'composer/load/contentCarrier',
  async (params: { uid: string }) => {
    return await load_contentCarriers(params)
  },
)

export const CreateContentCarrierAsync = createAsyncThunk<any, any>(
  'composer/create/contentCarrier',
  async (params: ContentCarrier) => {
    return await store_contentCarrier(params)
  },
)

export const DeleteContentCarrierAsync = createAsyncThunk<any, any>(
  'composer/delete/contentCarrier',
  async (params) => {
    return await delete_contentCarrier(params)
  },
)
